<div class="note" [ngClass]="getCSS()">
    <p>{{text}}</p>
</div>